/**
 * QueryProvider - Wraps the app with React Query's QueryClientProvider
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@business-assistant/shared';
import type { ReactNode } from 'react';

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
